import React, { FunctionComponent, useEffect, useState, useRef } from 'react'
import { getUsers } from 'Frontend/scripts/services/users.service'
import Paging from 'Features/Paging/paging'
import { IMembersSearchResults } from 'Frontend/scripts/models/members.model'

interface MembersListingProps {
  membersList: IMembersSearchResults
  selectedQuery?: string
  selectedCounty?: string
  selectedMunicipality?: string
  selectedCompetence?: string
}

const MembersListing: FunctionComponent<MembersListingProps> = ({
  membersList,
  selectedQuery,
  selectedCounty,
  selectedMunicipality,
  selectedCompetence,
}) => {
  const [members, setMembers] = useState<IMembersSearchResults>()
  const [pageIndex, setPageIndex] = useState<number>(1)
  const membersListRef = useRef<HTMLDivElement | null>(null)

  const changePage = (activePage: number) => {
    setPageIndex(activePage)
    membersListRef?.current && membersListRef.current.scrollIntoView()
  }

  useEffect(() => {
    getUsers(
      pageIndex,
      selectedQuery ? selectedQuery : '',
      Number(selectedCounty),
      Number(selectedMunicipality),
      Number(selectedCompetence),
    ).then((members) => setMembers(members))
  }, [pageIndex])

  useEffect(() => {
    setMembers(membersList)
  }, [membersList])

  return (
    <>
      <div className="d-flex flex-column gap-2" ref={membersListRef}>
        {members?.items?.map((member, index) => (
          <div key={`member-${index}`} className="flex-column livstecknet__listing-content-row workrooms__members-card">
            <a href={member.viewProfileUrl} className="workrooms__members-card-heading">
              {member.lastname}&nbsp;
              {member.firstname}
            </a>

            {member.mobilePhone && (
              <a href={`tel:${member.mobilePhone}`} className="workrooms__members-card-info">
                <span className="fa fa-mobile-phone me-2 workrooms__members-card-icon workrooms__members-card-icon--large"></span>{' '}
                {member.mobilePhone}
              </a>
            )}
            {member.phone && (
              <a href={`tel:${member.phone}`} className="workrooms__members-card-info">
                <span className="fa fa-phone me-2 workrooms__members-card-icon"></span> {member.phone}
              </a>
            )}
            {member.email && (
              <a href={`mailto:${member.email}`} className="workrooms__members-card-info">
                <span className="fa fa-envelope me-2 workrooms__members-card-icon"></span> {member.email}
              </a>
            )}
          </div>
        ))}
        {(members?.totalPages as number) > 1 && (
          <Paging
            noOfPages={members?.totalPages as number}
            activePage={members?.pageIndex as number}
            callback={(activePage) => {
              changePage(activePage)
            }}
          />
        )}
      </div>
    </>
  )
}

export default MembersListing
